import spvlightnodes from "./spvlightnodes"
import oracle from "./oracle"
import crosschain from "./crosschain"
import expansion from "./expansion"
import excellent from "./excellent"

export default {
  spvlightnodes: spvlightnodes,
  oracle: oracle,
  crosschain: crosschain,
  expansion: expansion,
  excellent: excellent
}